export default "__VITE_ASSET__e11a9e3a__"